<template>
  <div class="register-view">
    <site-menu theme="dark" class="menu"/>
    <div class="inner">
      <form v-show="step === 1" data-vv-scope="step-1" class="step-1">
        <div class="container">
          <p class="instructions">Pre-registration for the event and workshops is now open. Once your pre-registration form is received, it will go through a review process before being accepted for registration. There are a limited number of event attendee spaces, we highly encourage pre-registration as we have a big demand for tickets.</p>
          <div class="step-badge">Step 1/2</div>
        </div>
        <div class="field-group">
          <div class="col-3" v-if="hasPackage">
            <div class="field span-2">
              <select name="packageNumber" v-model="packageNumber">
                <option v-for="pck in packages" :value="pck.id">{{pck.title}}</option>
              </select>
            </div>
            <div class="field" v-if="isDailyPackage">
              <select name="packageDay" v-model="packageDay">
                <option v-for="day, index in days" :value="day.id">{{day.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div class="field span-2">
              <transition name="fade">
                <label v-if="newAttendee.email">Email</label>
              </transition>
              <input name="email" v-validate="'required'" v-model="newAttendee.email" placeholder="Email *" />
              <span class="error">{{ errors.first('email', 'step-1') }}</span>
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.phone">Phone</label>
              </transition>
              <input name="phone" v-validate="'required'" v-model="newAttendee.phone" placeholder="Phone *" />
              <span class="error">{{ errors.first('phone', 'step-1') }}</span>
            </div>
          </div>
          <div class="col-3">
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.title">Title</label>
              </transition>
              <input name="title" v-model="newAttendee.title" placeholder="Title" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.firstName">First Name</label>
              </transition>
              <input name="first name" v-model="newAttendee.firstName" placeholder="First Name" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.lastName">Last Name</label>
              </transition>
              <input name="last name" v-model="newAttendee.lastName" placeholder="Last Name" />
            </div>
          </div>
          <div class="col-3">
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.jobTitle">Job Title</label>
              </transition>
              <input name="job-title" v-model="newAttendee.jobTitle" placeholder="Job Title" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.company">Company</label>
              </transition>
              <input name="company" v-model="newAttendee.company" placeholder="Company" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.companyUrl">Company URL</label>
              </transition>
              <input name="company-url" v-model="newAttendee.companyUrl" placeholder="Company URL" />
            </div>
          </div>
          <div class="col-1">
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.address">Address</label>
              </transition>
              <input name="address" v-model="newAttendee.address" placeholder="Address" />
            </div>
          </div>
          <div class="col-4">
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.country">Country</label>
              </transition>
              <input name="country" v-model="newAttendee.country" placeholder="Country" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.state">State</label>
              </transition>
              <input name="state" v-model="newAttendee.state" placeholder="State" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.city">City</label>
              </transition>
              <input name="city" v-model="newAttendee.city" placeholder="City" />
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="newAttendee.zipCode">Zip Code</label>
              </transition>
              <input name="zip-code" v-model="newAttendee.zipCode" placeholder="Zip Code" />
            </div>
          </div>
          <div class="next" @click="goToStep2">Next</div>
        </div>
        <div class="required-notice">* Required fields</div>
      </form>
      <form v-show="step === 2" data-vv-scope="step-2" class="step-2">
        <div v-for="question in questions" class="q-wrapper">
          <div class="text q-title" v-if="question.title">{{question.title}}<span class="mandatory" v-if="question.mandatory">*</span></div>
          <span class="q-error" v-if="errors.first(question.field, 'step-2')">{{ errors.first(question.field, 'step-2') }}</span>
          <div
            class="field q-options"
            v-for="(option, index) in question.options"
            @click="setField(question, index)"
          >
            <div :class="question.type">
              <div v-if="isSelected(question, index)" :class="{'sw-check': question.type === 'checkbox'}"/>
            </div>
            {{option}}
          </div>
        </div>
        <div class="actions">
          <big-button main :action="submit" class="left" >Register!</big-button>
          <big-button :action="back" class="right">Back</big-button>
        </div>
        <div class="mandatory-notice">* Please fill out the mandatory fields</div>
      </form>
    </div>
    <divider />
    <illustration />
  </div>
</template>

<script>
  import { constants, formFactor } from '@/lib/utils'
  import BigButton from '@/components/BigButton.vue'
  import Illustration from '@/components/Illustration.vue'
  import Slideshow from '@/components/Slideshow.vue'
  import SiteMenu from '@/components/SiteMenu.vue'
  import Divider from '@/components/Divider.vue'
  import packages from '@/lib/packages'

  export default {
    name: 'register-view',
    components: { BigButton, Illustration, Slideshow, SiteMenu, Divider },
    data() {
      return {
        step: 1,
        newAttendee: {
          optinTmp: [0]
        },
        packageNumber: null,
        packageDay: null,
        confirmPassword: null,
        packages,
        days: [
          {
            id: 0,
            name: 'Date',
          },
          {
            id: 1,
            name: 'Wednesday, April 10th 2019',
          },
          {
            id: 2,
            name: 'Thursday, April 11th 2019',
          },
        ],
        questions: [{
          type: 'radio',
          title: 'What is your involvement in the Cannabis Industry?',
          mandatory: true,
          field: 'involvement',
          options: [
            'I work in the Cannabis Industry',
            'I want to work in the Cannabis Industry',
            'I would like to invest in the Cannabis Industry',
            'I research medicinal benefits of Cannabis',
          ],
        }, {
          type: 'radio',
          title: 'What part of the Cannabis Industry are you interested or involved in?',
          mandatory: true,
          field: 'employment',
          options: [
            'Cultivation',
            'Distribution',
            'Dispensary',
            'Delivery Service',
            'Product Manufacturer ',
            'Consulting Service',
            'Accountancy',
            'Legal Services',
            'Security',
            'Transportation',
            'Pharmacy',
          ],
        }, {
          type: 'checkbox',
          title: 'Which of the following topics would you be excited to learn more about during our 2019 Symposium?',
          mandatory: true,
          field: 'interests',
          options: [
            'Accounting & insurance services',
            'Advertising & marketing agencies',
            'Banking & payment processing services',
            'Botanicals',
            'Consulting services',
            'Containers/bottles/packaging',
            'Dispensing/vending machines',
            'Displays/fixtures',
            'Employment opportunities',
            'Grow lights',
            'Hemp products',
            'Hydroponics & cultivation products',
            'Infused edibles/beverages',
            'Inventory tracking',
            'Lab testing & equipment',
            'Lawyers & legal services',
            'Licensing services',
            'Medical resources',
            'Paraphernalia (headshop/smokeship goods)',
            'POS & management software',
            'Private equity & investment resources',
            'Professional training & education',
            'Security services & equipment',
            'Seed banks',
            'Tinctures/tonics/topicals',
            'Vaporizers',
          ],
        }, {
          type: 'radio',
          title: 'What is your age group?',
          field: 'ageRange',
          options: [
            '18-25',
            '25-35',
            '35-45',
            '45-55',
            '55-65 ',
            '65+',
          ],
        }, {
          type: 'checkbox',
          field: 'optinTmp',
          options: [ 'I subscribe to the Cannabis Political Economy Symposium newsletter' ],
        }]
      }
    },
    computed: {
      hasPackage() {
        return !isNaN(parseInt(this.$route.query.packageNumber))
      },
      isDailyPackage() {
        return this.hasPackage && this.packages[this.packageNumber].isDaily
      },
    },
    created() {
      if (this.hasPackage) {
        this.packageNumber = this.$route.query.packageNumber
        this.packageDay = 0
      }
    },
    methods: {
      goToStep2() {
        this.$validator.validateAll('step-1').then((result) => {
          if (result) {
            window.scrollTo(0, 0)
            this.step = 2
          }
        })
      },
      submit() {
        this.errors.clear('step-2')
        this.questions.filter(q => q.mandatory).forEach(q => {
          if (q.type === 'radio' && isNaN(this.newAttendee[q.field])) {
            this.errors.add({
              field: q.field,
              scope: 'step-2',
              msg: 'Please select an answer',
            })
          } else if (q.type === 'checkbox' && !this.newAttendee[q.field]) {
            this.errors.add({
              field: q.field,
              scope: 'step-2',
              msg: 'Please choose at least one answer',
            })
          }
        })
        if (this.errors.any()) {
          console.log(this.errors)
          this.$toasted.error('Please fill out all the mandatory fields')
          return
        }
        this.newAttendee.optin = this.newAttendee.optinTmp.length === 1
        this.newAttendee.package = this.packageNumber
        this.newAttendee.packageDay = this.packageDay
        this.$http.post('attendee', this.newAttendee)
        .then((response) => {
          this.$toasted.success('Thank you! We\'ve sent you a confirmation email')
          this.$router.push(this.$route.query.origin || '/')
        })
        .catch((response) => {
          this.$toasted.error(response.body.error)
        })
      },
      back() {
        this.step = 1
      },
      setField(question, value) {
        if (question.type === 'radio') {
          this.newAttendee[question.field] = value
        } else {
          this.newAttendee[question.field] = this.newAttendee[question.field] || []
          if (this.isSelected(question, value)) {
            this.newAttendee[question.field] = this.newAttendee[question.field].filter(v => v !== value)
          } else {
            this.newAttendee[question.field].push(value)
          }
        }
        this.$forceUpdate()
      },
      isSelected(question, value) {
        if (question.type === 'radio') {
          return this.newAttendee[question.field] === value
        } else {
          return this.newAttendee[question.field] && this.newAttendee[question.field].indexOf(value) > -1
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  .register-view {
    position: relative;
  }
  .banner {
    color: #fff;
    position: absolute;
    top: 240px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    padding: 30px 0;
    text-align: center;
    font-size: 22px;
  }
  input, select {
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }
  form.step-1 {
    margin: 0 40px 40px 40px;
  }
  form.step-2 {
    margin: 40px 20px;
  }
  .required-notice {
    margin-top: 5px;
    opacity: 0.5;
  }
  .field-group {
    background: $color-8;
    padding: 40px;
    .field input, .field select {
      background: $color-8;
      color: #fff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.7);
      padding: 15px 0;
    }
    .field label {
      color: #fff;
      opacity: 0.5;
      top: 2px;
      left: 0;
    }
    ::placeholder {
      color: $color-9;
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: $color-9;
    }
    ::-ms-input-placeholder {
      color: $color-9;
    }
  }
  .instructions {
    color: $color-8;
    text-align: justify;
    opacity: 0.5;
  }
  .step-badge {
    font-size: 10px;
    color: $color-8;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: right;
    opacity: 0.5;
    margin: 20px 0 5px 0;
  }
  .next {
    color: #fff;
    text-align: center;
    padding-top: 20px;
    font-size: 30px;
    opacity: 0.8;
    text-transform: uppercase;
    font-weight: 100;
    cursor: pointer;
    width: 200px;
    margin: 0 auto;
    &:hover {
      opacity: 1;
      font-weight: normal;
    }
  }
  .error {
    position: absolute;
    left: 0;
    bottom: -13px;
    width: 400px;
    color: lighten($red, 30%);
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 1px;
  }
  .q-title {
    margin-bottom: 10px;
  }
  .q-options {
    margin-bottom: 3px;
    overflow: hidden;
  }
  .q-error {
    color: lighten($red, 30%);
    font-weight: bold;
    font-size: 14px;
  }
  .actions {
    overflow: hidden;
    margin-bottom: 20px;
  }
  @media (max-width: 500px) {
    .register-view {
      padding-top: 0;
    }
    button.main {
      margin: 0 15px;
    }
    .register-view.inner .field {
      & {
        width: calc(100% - 30px);
      }
    }
    .q-wrapper {
      margin: 0 15px 20px 15px;
    }
    .mandatory-notice {
      margin-left: 15px;
    }
    form.step-1 {
      margin: 0 10px 40px 10px;
      .field {
        margin-top: 20px;
      }
    }
    form.step-2 {
      margin: 40px 10px;
    }
    .field-group {
      padding: 15px;
    }
    .instructions {
      font-size: 18px;
      margin: 60px auto 20px;
    }
    form.step-2 {
      margin: 60px 10px 40px;
    }
  }
  @media (min-width: 501px) {
    .register-view.inner .field {
      &:first-child {
        margin-left: 0;
      }
    }
    .q-wrapper {
      margin-bottom: 20px;
    }
    .col-3 .field {
      width: calc(33.3333% - 24px);
      &.span-2 {
        width: calc(66.6666% - 24px);
      }
    }
    .col-4 .field {
      width: calc(25% - 24px);
    }
    .col-1 .field {
      width: 100%;
    }
    .col-3, .col-4, .col-1 {
      width: 100%;
      overflow: hidden;
      .field {
        margin: 0 0 12px 24px;
        float: left;
      }
    }
    .instructions {
      font-size: 22px;
      width: 990px;
      margin: 40px auto 0;
    }
  }
</style>